import { DtoPedido } from './../../pedido/dominio/DtoPedido';
import { DtoCoLetraEstadoMast } from './../dominio/DtoCoLetraEstadosMast';
import { Injectable, Inject } from '@angular/core';
import { AppConfig } from 'src/environments/appconfig';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { ParametroPaginacionGenerico } from 'src/app/util/ParametroPaginacionGenerico';
import { FiltroCoDocumentoCobrar } from '../dominio/FiltroCoDocumentoCobrar';
import { MensajeUsuario } from 'src/app/util/mensajes/mensajeUsuario';
import { CoCobranza } from '../../cocobranza/dominio/CoCobranza';
import { DtoTabla } from 'src/app/util/dtotabla';
import { CoDocumento, CoDocumentoPk } from '../dominio/CoDocumento';
import { DtoCotizacionGenerarPedido } from '../../cotizacion/dominio/DtoCotizacionGenerarPedido';
import { DtoBanco } from '../dominio/DtoBanco';
import { DtoCoDocumentoCobrar } from '../dominio/DtoCoDocumentoCobrar';
import { UHttpsClient } from '../../../../seguridad/seguridad/uhttpsClient';
import { Direccion } from '../dominio/direccion';


@Injectable()
export class CoDocumentoServicio {
    private url = `${this.config.getEnv('proxy')}spring/comercial/codocumento/`;
    private urlDireccion = `${this.config.getEnv('proxy')}spring/core/direccion/`;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: UHttpsClient, private config: AppConfig) { }

    public listarDocumentosPorCobrarPaginacion(filtro: FiltroCoDocumentoCobrar): Promise<ParametroPaginacionGenerico> {
        return this.http.post(`${this.url}listarDocumentosPorCobrarPaginacion`, filtro, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as ParametroPaginacionGenerico;
            })
            .catch(error => new ParametroPaginacionGenerico());
    }

    public listarLetraPaginacion(filtro: FiltroCoDocumentoCobrar): Promise<ParametroPaginacionGenerico> {
        return this.http.post(`${this.url}listarLetraPaginacion`, filtro, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as ParametroPaginacionGenerico;
            })
            .catch(error => new ParametroPaginacionGenerico());
    }

    public cantidadDocumtosVencidos(filtro: FiltroCoDocumentoCobrar): Promise<DtoCoDocumentoCobrar> {
        return this.http.post(`${this.url}cantidadDocumtosVencidos`, filtro, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as DtoCoDocumentoCobrar;
            })
            .catch(error => new DtoCoDocumentoCobrar());
    }

    public cantidadDocumtosPorVencer(filtro: FiltroCoDocumentoCobrar): Promise<DtoCoDocumentoCobrar> {
        return this.http.post(`${this.url}cantidadDocumtosPorVencer`, filtro, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as DtoCoDocumentoCobrar;
            })
            .catch(error => new DtoCoDocumentoCobrar());
    }

    public cantidadLetrasAPeticion(filtro: FiltroCoDocumentoCobrar): Promise<DtoCoDocumentoCobrar> {
        return this.http.post(`${this.url}cantidadLetrasAPeticion`, filtro, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as DtoCoDocumentoCobrar;
            })
            .catch(error => new DtoCoDocumentoCobrar());
    }

    public obtenerAvanceVentas(filtro: FiltroCoDocumentoCobrar): Promise<DtoCoDocumentoCobrar> {
        return this.http.post(`${this.url}obtenerAvanceVentas`, filtro, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as DtoCoDocumentoCobrar;
            })
            .catch(error => new DtoCoDocumentoCobrar());
    }


    public registrar(bean: CoCobranza): Promise<MensajeUsuario[]> {
        return this.http.post(`${this.url}registrar`, bean, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as MensajeUsuario[];
            })
            .catch(error => null);
    }

    public actualizar(bean: CoCobranza): Promise<MensajeUsuario[]> {
        return this.http.post(`${this.url}actualizar`, bean, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as MensajeUsuario[];
            })
            .catch(error => null);
    }

    public obtenerAutorizacionDescuento04(bean: CoDocumento): Promise<CoDocumento> {
        return this.http.post(`${this.url}obtenerAutorizacionDescuento04`, bean, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as CoDocumento;
            })
            .catch(error => new CoDocumento);
    }

    public registrarPedido(bean: CoDocumento): Promise<CoDocumento> {
        return this.http.post(`${this.url}registrarPedido`, bean, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as CoDocumento;
            })
            .catch(error => null);
    }


    public aprobarRechazarPedido(bean: DtoPedido): Promise<CoDocumento> {
        return this.http.post(`${this.url}aprobarRechazarPedido`, bean, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as CoDocumento;
            })
            .catch(error => null);
    }

    public eliminarDetalle(bean: CoDocumento): Promise<CoDocumento> {
        return this.http.post(`${this.url}eliminarDetalle`, bean, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as CoDocumento;
            })
            .catch(error => null);
    }

    public validar(bean: CoDocumento): Promise<MensajeUsuario[]> {
        return this.http.post(`${this.url}validarPedido`, bean, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as MensajeUsuario[];
            })
            .catch(error => null);
    }

    public calcularDescuentos(bean: CoDocumento): Promise<CoDocumento> {
        return this.http.post(`${this.url}calcularDescuentos`, bean, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as CoDocumento;
            })
            .catch(error => null);
    }

    public actualizarCliente(bean: CoDocumento): Promise<CoDocumento> {
        return this.http.post(`${this.url}actualizarCliente`, bean, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as CoDocumento;
            })
            .catch(error => null);
    }

    public actualizarAlmacen(bean: CoDocumento): Promise<CoDocumento> {
        return this.http.post(`${this.url}actualizarAlmacen`, bean, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as CoDocumento;
            })
            .catch(error => null);
    }

    public wfSetprecios(bean: CoDocumento): Promise<CoDocumento> {
        return this.http.post(`${this.url}wfSetprecios`, bean, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as CoDocumento;
            })
            .catch(error => null);
    }

    public guardarPedido(bean: CoDocumento): Promise<CoDocumento> {
        return this.http.post(`${this.url}guardarPedido`, bean, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as CoDocumento;
            })
            .catch(error => null);
    }

    public actualizarCotizacion(bean: CoDocumento): Promise<CoDocumento> {
        return this.http.post(`${this.url}actualizarCotizacion`, bean, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as CoDocumento;
            })
            .catch(error => null);
    }


    public listarRutaDespacho(): Promise<DtoTabla[]> {
        return this.http.get(`${this.url}listarRutaDespacho`, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as DtoTabla[];
            })
            .catch(error => []);
    }

    public obtenerDireccion(cliente: number): Promise<DtoTabla[]> {

        const params = new HttpParams().set('cliente', JSON.stringify(cliente));

        return this.http.get(`${this.url}obtenerDireccion`, { params, headers: this.headers })
            .toPromise()
            .then(response => {
                return response as DtoTabla[];
            })
            .catch(error => []);
    }


    public obtenerDireccionPorId(persona: number, secuencia: number): Promise<Direccion> {
        const params = new HttpParams().set('persona', JSON.stringify(persona * 1))
            .set('secuencia', JSON.stringify(secuencia * 1));
        return this.http.get(`${this.urlDireccion}obtenerporid`, { params, headers: this.headers })
            .toPromise()
            .then(response => {
                return response as Direccion;
            })
            .catch(error => null);
    }

    public obtenerSeguridad(): Promise<number> {
        return this.http.get(`${this.url}obtenerSeguridad`, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as number;
            })
            .catch(error => 0);
    }

    public listarFormaFactura(): Promise<DtoTabla[]> {
        return this.http.get(`${this.url}listarFormaFactura`, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as DtoTabla[];
            })
            .catch(error => []);
    }

    public generarPedido(lst: DtoCotizacionGenerarPedido[]): Promise<CoDocumento> {
        return this.http.post(`${this.url}generarPedido`, lst, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as CoDocumento;
            })
            .catch(error => null);
    }

    public obtenerCompletoPorId(pk: CoDocumentoPk, accion: string): Promise<CoDocumento> {
        const params = new HttpParams().set('accion', accion);

        return this.http.post(`${this.url}obtenerCompletoPorId`, pk, {params, headers: this.headers })
            .toPromise()
            .then(response => {
                return response as CoDocumento;
            })
            .catch(error => null);
    }

    public listarEstadoLetras(): Promise<DtoCoLetraEstadoMast[]> {
        return this.http.get(`${this.url}listarLetraEstado`, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as DtoCoLetraEstadoMast[];
            })
            .catch(error => []);
    }

    public listarBancos(): Promise<DtoBanco[]> {
        return this.http.get(`${this.url}listarBancos`, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as DtoBanco[];
            })
            .catch(error => []);
    }

}

